import { render } from "./AnnotationCard.vue?vue&type=template&id=6cbd985a"
import script from "./AnnotationCard.vue?vue&type=script&lang=js"
export * from "./AnnotationCard.vue?vue&type=script&lang=js"

import "./AnnotationCard.vue?vue&type=style&index=0&id=6cbd985a&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__